/**
 * Chain information — derived from @b3/chain-registry (single source of truth).
 * To add a new chain, edit packages/chain-registry/chains.json.
 */
import { chains, CHAIN_IDS, chainById, buildQuicknodeRpcMap, FALLBACK_RPC_URLS } from "@b3/chain-registry";
import type { ChainDefinition } from "@b3/chain-registry";
import { HL_CHAIN_ID } from "@/lib/hyperliquid/constants";

export const CHAIN_INFO: Record<number, { name: string; gasToken: string }> = Object.fromEntries(
  chains.map((c: ChainDefinition) => [c.chainId, { name: c.name, gasToken: c.nativeCurrency.symbol }]),
);

export function getChainInfo(chainId: number): { name: string; gasToken: string } {
  if (chainId === HL_CHAIN_ID) return { name: "Hyperliquid", gasToken: "USDC" };
  return CHAIN_INFO[chainId] || { name: `Chain ${chainId}`, gasToken: "ETH" };
}

const QUICKNODE_SUBDOMAIN = process.env.NEXT_PUBLIC_QUICKNODE_SUBDOMAIN;
const QUICKNODE_KEY = process.env.NEXT_PUBLIC_QUICKNODE_KEY;

const quicknodeRpcs =
  QUICKNODE_SUBDOMAIN && QUICKNODE_KEY ? buildQuicknodeRpcMap(QUICKNODE_SUBDOMAIN, QUICKNODE_KEY) : {};

export const PUBLIC_RPC: Record<number, string> = {
  ...FALLBACK_RPC_URLS,
  ...quicknodeRpcs,
};

export const SOLANA_MAINNET_CHAIN_ID = CHAIN_IDS.SOLANA;
export const SOLANA_DEVNET_CHAIN_ID = CHAIN_IDS.SOLANA_DEVNET;
export const SOLANA_CHAIN_IDS = new Set([SOLANA_MAINNET_CHAIN_ID, SOLANA_DEVNET_CHAIN_ID]);

export function getNativeTokenDecimals(chainId: number | undefined): number {
  if (!chainId) return 18;
  return chainById.get(chainId)?.nativeCurrency.decimals ?? 18;
}
